import type { HelpContent } from "../../types";
import { analytics } from "./analytics";
import { crm } from "./crm";
import { faq } from "./faq";
import { hints } from "./hints";
import { menu } from "./menu";
import { sales } from "./sales";
import { settings } from "./settings";
import { staff } from "./staff";
import { start } from "./start";
import { stock } from "./stock";

export const helpRu = { categories: [start, sales, menu, stock, crm, staff, analytics, settings, faq], hints } satisfies HelpContent;
